export const OTP_LENGTH = 6

/** Default OTP validity window (matches common Liberty SMS OTP expiry). */
export const DEFAULT_OTP_EXPIRY_SECONDS = 10 * 60
